import styled, { keyframes } from 'styled-components';
import * as palette from '../../styles/variables';
const slideIn = keyframes` 
  0% {
    left: -100%;
    width: 0px; }
100% { 
  left: 0;
  width: 350px; 
}
`;
export const Container = styled.div`
  background: rgb(37, 41, 45) !important;
  height: calc(100% - 70px);
  top: 10px;
  position: relative;
  z-index: 99;
  animation: ${props => (props.display ? slideIn : 'none')} 0.5s ease-in-out;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  width: 350px;
  min-width: 350px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  .deleteButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
      background: ${palette.APP_BRAND_YELLOW_COLOR};
    }
  }
  &.full-height {
    height: 100%;
  }
  .scrollable {
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const FieldTitle = styled.div`
  width: ${props => (props.isSpacing ? '50%' : '85%')};
  color: ${props => (props.isStyleChange ? '#00c4cc' : props.isDisabled ? '#707070' : '#fff')};
  cursor: ${props => props.disabled && 'not-allowed'};
  padding: ${props => (props.isSpacing ? '0' : '0 20px 20px 0')};
  font-size: ${props => (props.isStyleChange ? '13px' : '14px')};
  display: flex;
  align-items: center;
  text-transform: ${props => props.isStyleChange && 'uppercase'};
  .anticon {
    margin-left: 12px;
  }
  .ant-switch {
    margin-left: 25px !important;
  }

  &.section-header {
    border-bottom: 1px solid;
    padding-bottom: 10px;
    margin-bottom: 10px;
    color: #e8f9fa;
  }
`;

export const PaddingOption = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px 0;
  align-items: center;
  .ant-input-number {
    width: 20%;
  }
`;

export const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  position: relative;
  padding: 0 20px 20px;
  .ant-input {
    width: 100% !important;
  }
  cursor: ${({disabled}) => disabled && 'not-allowed'};
  * {
    pointer-events: ${({disabled}) => disabled && 'none'};
  }
`;

export const RowSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  padding: 10px 0;
  .ant-select-selection {
    background-color: transparent !important;
    border: none !important;
    color: #fff !important;
    font-size: 15px !important;
  }
  .ant-select-selection:focus {
    box-shadow: none !important;
  }
  .ant-select-arrow {
    color: #fff !important;
  }

  ${FieldTitle} {
    padding: 0;
  }

  ${PaddingOption} {
    padding: 0;

    ${FieldTitle} {
      width: 35%;
    }

    .ant-input-number {
      width: 50%;
    }
  }

  .line-spacing-select {
    .ant-select-selection {
      background-color: #fff !important;
      border: 1px solid #d9d9d9 !important;
      color: rgba(0, 0, 0, 0.65) !important;
      font-size: 14px !important;
    }
    .ant-select-selection:hover {
      border-color: #40a9ff !important;
    }
    .ant-select-selection:focus,
    .ant-select-selection-focused {
      border-color: #40a9ff !important;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    }
    .ant-select-arrow {
      color: rgba(0, 0, 0, 0.25) !important;
    }
  }
`;

export const BlockColor = styled.div`
  height: 25px;
  width: 25px;
  border: 1px solid #fff;
  background: ${props => props.background};
  border-radius: 5px;
  pointer-events: ${props => props.disabled ? 'none' : 'all'};
`;

export const ComplexBlockSettingsTabsContainer = styled.div`
  padding-top: 10px;
  .ant-tabs-tabpane {
    align-items: center;
  }
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
  .deleteButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
      background: ${palette.APP_BRAND_YELLOW_COLOR};
    }
  }
  .note-text {
    color: #fbfbfb;
    font-size: 14px;
    font-style: italic;
  }
`;

export const StyledTabPane = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(90dvh - 50px);
  justify-content: space-between;
  align-items: center;
  cursor: ${({disabled}) => disabled && 'not-allowed'};
  * {
    pointer-events: ${({disabled}) => disabled && 'none'};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const TabPaneBody = styled.div`
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  height: inherit;
`;

